import DataUse from "../../All-brand-logo/Brands_Logo_All";

let DataUseHere=[
    {type:"other",data:{name:"Option",option:["All","Standard","Full","Half Full"]}},
    {type:"other",data: {name:"Condition",option:["All-condetion","New-Car","User-Car"]}},
    {type:"other",data: {name:"kilometer",option:["From 0 to 50km","From 50 to 70km","From 70 to 100km","From 100 to 130km","From 130 to 170km ","From 170 to 200km","More Than 200km"]}},
    {type:"logo-car",data:{name:"CarBrands",option:DataUse}},
    {type:"other",data:{name:"Color",option:["White","Black","Silver","Red","Brwon","Blue","Green","Yellow","Grey","Dark Blue","Oil Green","Orange","Golden","Bronze","Beige","Camel","Nardo Gray","Dark Brown"]}},
    {type:"other",data: {name:"Gear",option:["Normal","Automatic","Cvt"]}},
    {type:"other",data: {name:"Fuel",option:["Gasoline","Diesel","Hybrid","Electricity"]}},
    {type:"other",data: {name:"EngineSize",option:["1","1.4","1.5","1.6","1.8","1.9","2","2.4","2.5","3","3.5","4","4.6","5","5.5","6"]}},
    {type:"other",data: {name:"Origin",option:["Saudi","Gulf","Other"]}},
    {type:"other",data: {name:"ShapeCars",option:["Sedan","Pickup","SUV","CrossOvers","Sport","Hatchback","Van"]}},
 ]

 export default DataUseHere